exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports
exports.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Roboto:300,400,500,700);", ""]);

// module
exports.push([module.id, ".text-red {\n  color: red; }\n\n.fieldset {\n  margin: 2rem auto;\n  border: 1px #ccc solid;\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-wrap: wrap;\n  flex-wrap: wrap; }\n  .fieldset .label {\n    font-weight: bold; }\n  .fieldset .w-full {\n    width: 100%; }\n  .fieldset .w-1\\/2 {\n    width: 50%; }\n  .fieldset .w-1\\/5 {\n    width: 20%; }\n  .fieldset .w-4\\/5 {\n    width: 80%; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1}!./node_modules/sass-loader/lib/loader.js!./node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null,null]}!./src/screens/serviceProtocol/ServiceProtocol.scss
// module id = 1762
// module chunks = 0